import type { JobListQuery } from '@chukua/common';
import { Segmented } from 'antd';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import { activeQuickFilter, JOB_QUICK_FILTERS, type JobQuickFilterKey } from '../policies/job-quick-filters';

interface JobQuickFiltersProps {
  list: Pick<ListQueryControls<JobListQuery>, 'query' | 'setQuery'>;
}

/** One-click status presets above the table; they set the same `status` filter as the column's menu (gitaumoses4/chukua#40). */
export function JobQuickFilters({ list }: JobQuickFiltersProps) {
  const active = activeQuickFilter(list.query.status);

  return (
    <Segmented<JobQuickFilterKey | 'custom'>
      aria-label="Quick filters"
      value={active ?? 'custom'}
      options={[
        ...JOB_QUICK_FILTERS.map(({ key, label }) => ({ value: key, label })),
        ...(active ? [] : [{ value: 'custom' as const, label: 'Custom', disabled: true }]),
      ]}
      onChange={(key) => {
        const preset = JOB_QUICK_FILTERS.find((filter) => filter.key === key);
        if (preset) list.setQuery({ status: preset.statuses });
      }}
    />
  );
}
